import { SectionName } from "./constants/sections";

import Residence from "./residence/Residence";
import Transport from "./transport/Transport";
import Energy from "./energy/Energy";
import Nutrition from "./nutrition/Nutrition";
import HouseholdHabits from "./householdHabits/HouseholdHabits";

interface SectionProps {
  section: SectionName;
  step: number;
}

function Section({ section, step }: SectionProps) {
  switch (section) {
    case "residence":
      return <Residence step={step} />;

    case "transport":
      return <Transport step={step} />;

    case "energy":
      return <Energy step={step} />;

    case "nutrition":
      return <Nutrition step={step} />;

    case "householdHabits":
      return <HouseholdHabits step={step} />;

    default:
      return (
        <h1>
          {section}: {step}
        </h1>
      );
  }
}

export default Section;
